module.exports = __webpack_public_path__ + "img/gb961.prt.64054fee.jpg";